<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh" @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import staffTableMixin from "../mixin/table";

export default {
  name: "StaffTempEscort",
  mixins: [tableMixin, staffTableMixin],
  data() {
    return {
      baseUrl: 'shortescort',
      breadcrumb: [
        { name: "人员管理", path: `/staff/tempEscort` },
        { name: "打短押运管理", path: `/staff/tempEscort` },
      ],
      formCtrl: [
        {
          label: "姓名",
          keyName: "name",
          placeholder: "请填写姓名",
          type: "text",
        },
        /*{
          label: "性别：",
          keyName: "sex",
          placeholder: "请选择性别",
          type: "select",
          options: [
            { label: '男', value: '男' },
            { label: '女', value: '女' },
          ],
        },*/
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/staff/tempEscortDetail?mode=view&id=${id}`
            );
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/staff/tempEscortDetail?mode=edit&id=${id}`
            );
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id);
          },
        },
      ],
      baseParams: [],
    };
  },
  methods: {
    addItem() {
      this.$router.push(`/staff/tempEscortDetail`);
    },
  },
};
</script>
